import React, { useState } from 'react'
import { Header } from '@crossfit/ui'

import type { Invitee } from 'types'
import SearchForm from './SearchForm'
import InviteForm from './InviteForm'
import usePageTitle from 'hooks/usePageTitle'
import style from './style.module.scss'

function InviteTeammatePage() {
  usePageTitle('CrossFit Affiliate Toolkit | Team Management')
  const [invitees, setInvitees] = useState<Invitee[]>([])

  function handleSelectResult(invitee: Invitee) {
    setInvitees((currentInvitee) => [...currentInvitee, invitee])
  }

  function handleRemove(index: number) {
    setInvitees((currentInvitees) =>
      currentInvitees.filter((_, i) => i !== index),
    )
  }

  return (
    <>
      {/* <PageHeader title={'ADD A TEAMMATE'} hideLinks={true} /> */}
      <section className={style.wrapper}>
        <Header size='large' as='h2' mb={12}>
          Invite Teammates
        </Header>

        <SearchForm onSelect={handleSelectResult} />

        <InviteForm invitees={invitees} onRemove={handleRemove} />
      </section>
    </>
  )
}

export default InviteTeammatePage
